import { render, staticRenderFns } from "./ModeloMensagemPrincipal.vue?vue&type=template&id=9e29a482&"
import script from "./ModeloMensagemPrincipal.vue?vue&type=script&lang=js&"
export * from "./ModeloMensagemPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports